<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长服务</el-breadcrumb-item>
        <el-breadcrumb-item>学长服务</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长服务</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="学长"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入姓名/手机号"
                    @input="fetchSeniorList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="院校"
                      prop="college">
          <el-input v-model="query.college"
                    @input="fetchSeniorList(true)"
                    placeholder="输入院校名称/代码"
                    clearable></el-input>
        </el-form-item>
        <!--       <el-form-item
          label="学院"
          prop="major"
        >
          <el-input
            v-model="query.academy"
            placeholder="输入学院名称/代码"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="专业"
                      prop="major">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.major"
                    placeholder="输入专业名称/代码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="学院">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.academy_keyword"
                    placeholder="输入学院名称/代码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="科目">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.subject_keyword"
                    clearable
                    placeholder="输入科目名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchSeniorList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="累计收益大于"
                      prop="user_total_profit_amount_low ">
          <el-input @input="searchSetTimeout"
                    v-model="query.user_total_profit_amount_low"
                    placeholder="输入数字"
                    oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="邀请人"
                      prop="status">
          <el-select v-model="query.invite_info"
                     placeholder="请选择"
                     @input="fetchSeniorList(true)">
            <el-option v-for="(item, index) in invite_options"
                       :key="index"
                       :label="item.invite_info"
                       :value="item.invite_info">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招呼语">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.default_greet_message_keyword "
                    placeholder="请输入招呼语"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="排序"
                      prop="chat_dialog_count_order_type">
          <el-select v-model="query.chat_dialog_count_order_type "
                     placeholder="请选择"
                     @input="fetchSeniorList(true)">
            <el-option v-for="(item, index) in filter.chat_type"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">查找结果</h3>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  v-loading="loading">
          <el-table-column prop="id"
                           label="用户ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="realname"
                           label="姓名/手机号"
                           min-width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.realname }}/{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column label="院校"
                           min-width="120"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recruit_college_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学院"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recruit_academy_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           min-width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>({{ scope.row.recruit_major_code || "-" }}){{
                  scope.row.recruit_major_name || "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "正常" : "禁用" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="服务标签"
                           width="200"
                           align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.servicer_tag_list">
                <el-tag size="small"
                        style="marginRight:5px;marginBottom:5px"
                        v-for="(tag,index) in scope.row.servicer_tag_list"
                        :key="index">
                  <span v-if="tag.tag_code.length==5"
                        style="marginBottom:5px">{{tag.tag_name}}（院校）</span>
                  <span v-if="tag.tag_code.length==6">{{tag.tag_code}}{{tag.tag_name}}（专业）</span>
                  <span v-if="tag.tag_code.length==3">{{tag.tag_code}}{{tag.tag_name}}（科目）</span>
                </el-tag>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="会话数量"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.chat_dialog_count}}
            </template>
          </el-table-column>
          <el-table-column label="招呼语"
                           width="400"
                           align="left">
            <template slot-scope="scope">
              {{scope.row.default_greet_message}}
            </template>
          </el-table-column>
          <el-table-column label="入驻时间"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              {{
                scope.row.apply_log_create_time
                  ? $moment(scope.row.apply_log_create_time).format(
                      "YYYY-MM-DD HH:mm"
                    )
                  : ""
              }}
            </template>

          </el-table-column>
          <el-table-column label="通过时间"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="200"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToSeniorEdit(scope.row, scope.$index)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToSeniorService(scope.row, scope.$index)">服务</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <SeniorCreate :visible="createDialog"
                  @close="createDialog = false"
                  @submit="fetchSeniorList"></SeniorCreate>
    <ApplyDialog :visible="applyDialogVisible"
                 :content="applyItem"
                 @submit="ApplyDialogSubmit"
                 @close="applyDialogVisible = false" />

    <TagCreate :visible="tagDialogVisible"
               :tagDetail="tagDetail"
               @submit="fetchSeniorList"
               @close="tagDialogVisible = false">
    </TagCreate>
    <Greeting :visible="serviceDialogVisible"
              :serviceDetail="serviceDetail"
              @submit="fetchSeniorList"
              @close="serviceDialogVisible = false">

    </Greeting>
  </div>
</template>

<script>
import { seniorList, seniorDestroy } from '@/api/senior'
import SeniorCreate from '@/components/dialog/senior/SeniorCreate'
import TagCreate from '@/components/dialog/senior/tagCreate'
import Greeting from '@/components/dialog/senior/sendGreeting'
// ApplyDialog之前是学长申请页面的表格详情弹窗，现在成为学长管理页面的表格详情弹窗
import ApplyDialog from '@/components/dialog/senior/Apply'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    SeniorCreate,
    ApplyDialog,
    TagCreate,
    Greeting,
  },
  data() {
    return {
      applyDialogVisible: false,
      serviceDialogVisible: false,
      tagDialogVisible: false,
      applyItem: {},
      createDialog: false,
      editRow: {},
      serviceDetail: {},
      tagDetail: {},
      query: {
        is_statistic_senior: 1,
        keyword: '',
        status: '',
        college: '',
        major: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        chat_dialog_count_order_type: '',
        // is_invite_list: 1,
      },
      pageTotal: 1000,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '禁用', value: '0' },
        ],
        recommed: [
          { label: '是', value: '1' },
          { label: '否', value: '0' },
        ],
        chat_type: [
          { label: '全部', value: '' },
          { label: '会话量正序', value: '2' },
          { label: '会话量降序', value: '1' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      loading: false,
      invite_options: [],
    }
  },
  created() {
    this.parseQuery()
    this.fetchSeniorList()
    this.inviterList()
  },
  methods: {
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchSeniorList(true)
      }, TimerTime)
    },

    // 邀请人
    inviterList() {
      let data = { ...this.query }
      data.is_invite_list = 1
      data.pageIndex = 1
      data.pageSize = 1
      seniorList(data).then((res) => {
        this.invite_options = res.invite_list
      })
    },
    // 用户列表
    fetchSeniorList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      this.query.is_get_chat = 1
      this.query.auto_recommend_status = 1
      seniorList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count || 0
        // this.invite_options = res.invite_list;
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSeniorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSeniorList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchSeniorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchSeniorList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        0: '禁用',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 学长详情
    handleToSeniorDetail(row) {
      this.applyItem = JSON.parse(JSON.stringify(row))
      this.applyDialogVisible = !this.applyDialogVisible
    },

    handleToSeniorEdit(row) {
      this.serviceDetail = row
      this.serviceDialogVisible = true
    },
    handleToSeniorService(row) {
      this.tagDetail = row
      this.tagDialogVisible = true
    },

    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    // 详情弹窗关闭
    ApplyDialogSubmit() {
      this.applyDialogVisible = false
      this.fetchSeniorList()
    },
    serviceDialogSubmit() {},
    deleteItem(item) {
      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          seniorDestroy({ id: item.id }).then((res) => {
            this.$nextTick(() => {
              this.fetchSeniorList()
            })
          })
        })
        .catch(() => {
          this.$notify.error({
            title: '提示',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .table-header {
      margin: 8px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  margin: 0px 8px;
  font-size: 12px;
}
</style>
